import styled from 'react-emotion'
import { color } from 'bvdash/styles'

const HelpText = styled.div`
  ${color.waterloo};
  font-size: 14px;
  line-height: 1.57;

  margin-bottom: 20px;
`

export default HelpText
